import { axiosInstance } from '../Authentication/AxiosInterceptor';

export interface ActiveClient {
  clientId: string;
  clientName: string;
  timestamp: string;
}

export interface SetActiveClientRequest {
  clientId: string;
}

export interface SetActiveClientResponse {
  clientId: string;
  clientName: string;
  timestamp: string;
  message: string;
}

export const clientService = {
  async getCurrentUserActiveClient(): Promise<ActiveClient | null> {
    try {
      const response = await axiosInstance.get<ActiveClient>('/GetCurrentUserActiveClient');
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      console.error('Error getting active client:', error);
      throw error;
    }
  },

  async setCurrentUserActiveClient(clientId: string): Promise<SetActiveClientResponse> {
    try {
      const response = await axiosInstance.post<SetActiveClientResponse>(
        '/SetCurrentUserActiveClient',
        { clientId } as SetActiveClientRequest
      );
      return response.data;
    } catch (error: any) {
      console.error('Error setting active client:', error);
      throw error;
    }
  }
};
